import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useState } from 'react';
import {
  Offcanvas, Button, ButtonGroup, Form,
} from 'react-bootstrap';
import { faPalette, faRotateRight } from '@fortawesome/free-solid-svg-icons';
import Flex from '../common/Flex';
import AppContext from '../context/Context';
import defaultModeImg from '../../../assets/img/generic/6.jpg';
import darkModeImg from '../../../assets/img/generic/5.jpg';
import invertedImg from '../../../assets/img/generic/inverted.png';
import cardImg from '../../../assets/img/generic/card.png';
import vibrantImg from '../../../assets/img/generic/vibrant.png';
import transparentImg from '../../../assets/img/generic/default.png';
import arrowsH from '../../../assets/img/icons/arrows-h.svg';
import paragraph from '../../../assets/img/icons/paragraph.svg';
import RadioItem from './RadioItem';

function SettingsPanel() {
  const {
    config: {
      isFluid,
      // isRTL,
      isDark,
      navbarPosition,
      navbarStyle,
      showSettingPanel,
      disabledNavbarPosition,
    },
    setConfig,
    configDispatch,
  } = useContext(AppContext);

  const [navbars] = useState([
    {
      uaname: 'Прозорий',
      name: 'transparent',
      image: transparentImg,
    },
    {
      uaname: 'Зворотний',
      name: 'inverted',
      image: invertedImg,
    },
    {
      uaname: 'Картковий',
      name: 'card',
      image: cardImg,
    },
    {
      uaname: 'яскравий',
      name: 'vibrant',
      image: vibrantImg,
    },
  ]);

  return (
    <Offcanvas
      show={showSettingPanel}
      onHide={() => setConfig('showSettingPanel', false)}
      placement="end"
      style={{ maxWidth: '22rem' }}
      className="border-0"
    >
      <Offcanvas.Header
        closeButton
        closeVariant="white"
        className="bg-shape settings-panel-header"
      >
        <Offcanvas.Title as="div" className="py-1 z-index-1 light">
          <div className="d-flex justify-content-between align-items-center mb-1">
            <h5 className="text-white">
              <FontAwesomeIcon icon={faPalette} className="me-2 fs-0" />
              Налаштувати
            </h5>
            <Button
              variant="primary"
              size="sm"
              className="rounded-pill mt-0 mb-0"
              style={{ fontSize: '12px' }}
              onClick={() => {
                configDispatch({ type: 'RESET' });
              }}
            >
              <FontAwesomeIcon
                icon={faRotateRight}
                style={{ fontSize: '10px' }}
                className="me-1"
              />
              Скинути
            </Button>
          </div>
          <p className="mb-0 fs--1 text-white opacity-75">
            Встановіть власний індивідуальний стиль
          </p>
        </Offcanvas.Title>
      </Offcanvas.Header>
      {/* <ScrollBarCustom> */}
      <Offcanvas.Body className="scrollbar">
        <h5 className="fs-0">Кольорова схема</h5>
        <p className="fs--1">Виберіть колірний режим.</p>

        <ButtonGroup className="btn-group-navbar-style">
          <RadioItem
            name="theme-mode"
            label="світлий"
            active={!isDark}
            onChange={({ target }) => setConfig('isDark', !target.checked)}
            image={defaultModeImg}
          />
          <RadioItem
            name="theme-mode"
            label="темний"
            active={isDark}
            onChange={({ target }) => setConfig('isDark', target.checked)}
            image={darkModeImg}
          />
        </ButtonGroup>

        {/* <hr /> */}

        {/* <Flex justifyContent="between"> */}
        {/*  <img */}
        {/*    src={leftArrowFromLeft} */}
        {/*    alt="" */}
        {/*    width={20} */}
        {/*    className="me-2 h-100" */}
        {/*  /> */}
        {/*  <div className="flex-1"> */}
        {/*    <h5 className="fs-0">Праворуч/Ліворуч</h5> */}
        {/*    <p className="fs--1 mb-0">Змініть розташування панелей</p> */}
        {/*  </div> */}
        {/*  <Form.Check */}
        {/*    type="switch" */}
        {/*    id="rtl-switch" */}
        {/*    checked={isRTL} */}
        {/*    onChange={({ target }) => setConfig('isRTL', target.checked)} */}
        {/*  /> */}
        {/* </Flex> */}
        <hr />

        <Flex justifyContent="between">
          <img src={arrowsH} alt="" width={20} className="me-2 h-100" />
          <div className="flex-1">
            <h5 className="fs-0">Макетування</h5>
            <p className="fs--1 mb-0">Розташування компонентів</p>
          </div>
          <Form.Check
            type="switch"
            id="fluid-mode-switch"
            checked={isFluid}
            onChange={({ target }) => setConfig('isFluid', target.checked)}
          />
        </Flex>
        <hr />

        <Flex>
          <img src={paragraph} alt="" width={20} className="me-2 h-100" />
          <div>
            <Flex alignItems="center" tag="h5" className="fs-0">
              Навігація
            </Flex>
            <p className="fs--1 mb-2">
              Виберіть варіант навігації в системі
            </p>
            <Form.Select
              className="mb-3"
              size="sm"
              defaultValue={navbarPosition}
              onChange={({ target }) => setConfig('navbarPosition', target.value)}
            >
              {[
                { value: 'vertical', name: 'Вертикальний' },
                { value: 'top', name: 'Зверху' },
                { value: 'combo', name: 'Комбінований' },
                { value: 'double-top', name: 'Зверху, подвоєний' },

              ].map((option) => (
                <option
                  key={option.value}
                  disabled={disabledNavbarPosition.includes(option.value)}
                  value={option.value}
                >
                  {option.name}
                </option>
              ))}
            </Form.Select>
          </div>
        </Flex>

        <hr />
        <h5 className="fs-0 d-flex align-items-center">
          Стиль вертикальної панелі навігації
          {' '}
        </h5>
        <p className="fs--1">Перемикання між стилями панелі навігації</p>
        <ButtonGroup className="btn-group-navbar-style">
          {navbars.slice(0, 2).map((item) => (
            <RadioItem
              key={item.name}
              name="navbar-style"
              label={item.uaname}
              active={navbarStyle === item.name}
              onChange={() => setConfig('navbarStyle', item.name)}
              image={item.image}
            />
          ))}
        </ButtonGroup>
        <ButtonGroup className="btn-group-navbar-style">
          {navbars.slice(2, 4).map((item) => (
            <RadioItem
              key={item.name}
              name="navbar-style"
              label={item.uaname}
              active={navbarStyle === item.name}
              onChange={() => setConfig('navbarStyle', item.name)}
              image={item.image}
            />
          ))}
        </ButtonGroup>
        <hr />
      </Offcanvas.Body>
      {/* </ScrollBarCustom> */}
    </Offcanvas>
  );
}

export default SettingsPanel;
